import {
  Badge,
  createTableColumn,
  TableColumnDefinition,
} from "@fluentui/react-components";
import { Image } from "../../models/Image";
import {
  ImageFileNameColumn,
  ModifiedByFieldColumn,
  PublishedDateFieldColumn,
  VersionFieldColumn,
} from "../../constants/DataGridColumns";
import GenericDataGrid from "../list/GenericDataGrid";
import { FieldColumnSizes } from "../../services/GenericDataGridService";
import { Translation, useTranslation } from "react-i18next";
import { ClientRoutes } from "../../models/ClientRoutes";
import TitleDataGridCell from "../list/TitleDataGridCell";

interface ImageHistoryDataGridProps {
  images: Image[];
}

const ImageHistoryDataGrid = (props: ImageHistoryDataGridProps) => {
  const { images } = props;
  const { t } = useTranslation();

  const columns: TableColumnDefinition<Image>[] = [
    {
      columnId: "title",
      compare: (a, b) => a.title.localeCompare(b.title),
      renderHeaderCell: () => (
        <Translation>{(t) => <p>{t("title")}</p>}</Translation>
      ),
      renderCell: (item) => {
        const isCurrent =
          images.length > 0 && images[0].versionId === item.versionId;
        return (
          <>
            <TitleDataGridCell
              item={item}
              route={`${ClientRoutes.MediaActivityEdit}/overview/${item.versionId}`}
            />
            {isCurrent && (
              <Badge appearance="filled" color="informative">
                {t("active")}
              </Badge>
            )}
          </>
        );
      },
    },
    createTableColumn<Image>(
      ImageFileNameColumn as TableColumnDefinition<Image>
    ),
    createTableColumn<Image>(
      VersionFieldColumn as TableColumnDefinition<Image>
    ),
    createTableColumn<Image>(
      ModifiedByFieldColumn as TableColumnDefinition<Image>
    ),
    createTableColumn<Image>(
      PublishedDateFieldColumn as TableColumnDefinition<Image>
    ),
  ];

  return (
    <GenericDataGrid<Image>
      getRowId={(image) => (image.versionId ? image.versionId : "")}
      items={images}
      columnSizingOptions={FieldColumnSizes}
      columns={columns}
    />
  );
};

export default ImageHistoryDataGrid;
